import React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { enquote } from '~/eds/src/utils/enquote';
import { Filter } from '~/evifields/src/types/Filter';
import { ClauseValue } from '~/evifields/src/types/Value';

import { TextContainer } from '../TextContainer';
import { serializeClauseFilter } from '../utils';

interface Props {
  filter: Filter<ClauseValue>;
}

export const ClauseValuesPreview = ({ filter }: Props) => {
  const intl = useIntl();
  const { provisionText, clauseSearchOperatorLabel, clauseSearchText } =
    serializeClauseFilter(filter, intl);

  return (
    <Layout align="center" spacing={1} minW={0}>
      <TextContainer text={provisionText || ''} />
      {clauseSearchOperatorLabel && (
        <strong>{clauseSearchOperatorLabel}</strong>
      )}
      {clauseSearchText && <TextContainer text={enquote(clauseSearchText)} />}
    </Layout>
  );
};
